import { useViewModel } from '@rehaje/react'

import { ValuableModel } from '../models/ValuableModel'

export const useValuableModel = <T extends ValuableModel>(): T | undefined => {
  const model = useViewModel()
  return (model instanceof ValuableModel ? model : undefined) as T | undefined
}
